// Don't send players' personal data: no user info, cookies, headers, bodies, or URL query
// parameters (invitation links will carry secret tokens there).
export const privateDataCollection = {
  userInfo: false,
  cookies: false,
  httpHeaders: false,
  httpBodies: [],
  urlQueryParams: false,
}

function meta(name: string) {
  return document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content || undefined
}

/**
 * Reports browser errors to Sentry when the server turned it on (meta tags from
 * SentryHelper#sentry_meta_tags, production only). The SDK is loaded only in that case,
 * so development and pages without Sentry don't download it.
 */
export async function initSentry() {
  const dsn = meta('sentry-dsn')
  if (!dsn) return false

  const Sentry = await import('@sentry/react')
  Sentry.init({
    dsn,
    release: meta('sentry-release'),
    environment: meta('sentry-environment'),
    dataCollection: privateDataCollection,
  })
  return true
}
